import { FC } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

export const NEW_PROVIDER_REPORT_NO_PUBLISHED_RUN_MESSAGE =
  "This project does not have a published run. Please try generating the report again once a published run is available.";

const NewProviderReportNoPublishedRunNotice: FC = () => {
  return (
    <div
      className="d-flex align-items-center bg-white border rounded-bottom p-3 text-info"
      data-testid="new-provider-report__no-published-run-notice"
      role="note"
    >
      <QesIcon
        iconName={QesIcons.InfoCircle}
        description="Information"
        className="flex-shrink-0 me-2"
        width="20"
      />
      <span>{NEW_PROVIDER_REPORT_NO_PUBLISHED_RUN_MESSAGE}</span>
    </div>
  );
};

export default NewProviderReportNoPublishedRunNotice;
